/* eslint-disable import/prefer-default-export */
import type { MonitorInfo } from '../../../../endpoints/services/intentMgr.service'
export interface GuardrailInfo extends MonitorInfo {
  categories?: string[]
}
export const defaultState = {
  monitoringList: [] as GuardrailInfo[],
  showOnlyEnabledGuardrails: false,
  monitorsCount: {
    total: 0,
    active: 0
  },
  monitorInfo: {} as GuardrailInfo,
  isPending: false,
  error: null as any
}
export type MonitoringState = typeof defaultState
